// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__V8Lu+","footer__logo":"Footer_footer__logo__vUYWf"};